import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, map, of, from, throwError, distinct, flatMap, toArray, tap, switchMap } from 'rxjs';
import { YearObject, YearResponse } from '../interfaces';
import { PivotGridConfig, pivotGridConfig } from '../utils/pivot-grid-config';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PivotGridConfigService {

  isMysqlDriver: boolean;

  constructor(private httpClient: HttpClient) {
    this.isMysqlDriver = environment.DB_DRIVER === "mysql" || false;
  }

  getPivotGridConfig(reportId: string | null): Observable<PivotGridConfig | null> {
    if (reportId && pivotGridConfig[reportId]) {
      return of(pivotGridConfig[reportId]);
    }

    return throwError(() => new Error('report not found'));
  }

  getReportId(reportId: string | null): Observable<string | null> {
    if (reportId) {
      return of(reportId);
    }

    return throwError(() => new Error('report not found'));
  }

  getDistinctYears(reportId: string): Observable<YearObject[]> {

    let result$: Observable<any> = new Observable;

    const distinctYearsUrl = (this.isMysqlDriver)
      ? `/odata/v4/public/${reportId}?$orderby=yr desc&$apply=groupby((yr,public))`
      : `/odata/v4/public/${reportId}?$orderby=date&$apply=groupby((date, public))`

    if (this.isMysqlDriver) {
      result$ = this.httpClient.get<YearResponse>(distinctYearsUrl).pipe(
        map((years: YearResponse) =>
          years.value.map((item: YearObject) => ({
            yr: item.yr.toString(),
            public: item.public,
          }))
        )
      );
    } else {

      result$ = this.httpClient.get<YearResponse>(distinctYearsUrl).pipe(
        map((years: YearResponse) => years.value),
        switchMap(dateItems => from(dateItems)),
        map((item: YearObject) => { return { "yr": item.yr, "public": item.public }; }),
        distinct((e: YearObject) => e.yr),
        toArray(),
        tap(dy => console.debug('District yeras: ', dy))
      );
    } // end if

    return result$
  }

}